(function(window, document, $, undefined){
  
  
  // -----------------------------------------------------------------------------------------------------
  // main navigation and mobile menu
  // -----------------------------------------------------------------------------------------------------

  // prevent jump on placeholder submenus (or use 'javascript:void(0);' for links and remove this)
  // $('.main-navigation li.menu-item-has-children > a').click(function(e) {
  //   e.preventDefault();
  // });


  // search bar expand
  $('.main-navigation li.search').click(function(e) {
    e.preventDefault();
    // $('.site-header .search-bar').slideToggle('fast');
    // $('.site-header .search-input').focus();
    var icon = $(this);
    var searchBar = $('.site-header .search-bar');
    if(searchBar.hasClass('open')){
      //close
      icon.removeClass('fa-times');
      icon.addClass('fa-search');
      $('.site-header .search-bar').slideUp('fast',function(){
        searchBar.removeClass('open');
      });
    } else {
      //open
      icon.removeClass('fa-search');
      icon.addClass('fa-times');
      searchBar.addClass('open');
      $('.site-header .search-bar').slideDown('fast');
      $('.site-header .search-input').focus();
    }


  });

  // mobile menu open
  $('.site-header .mobile-menu-trigger').click(function(e) {
    e.preventDefault();
    $('.mobile-navigation').addClass('open');
    $('.mobile-navigation-underlay').addClass('active');
  });

  // mobile menu close
  $('.mobile-navigation .close-mobile-menu, .mobile-navigation-underlay').click(function(e) {
    e.preventDefault();
    $('.mobile-navigation').removeClass('open');
    $('.mobile-navigation-underlay').removeClass('active');
  });




  // -----------------------------------------------------------------------------------------------------
  // mobile off-canvas menu expanding submenus
  // -----------------------------------------------------------------------------------------------------

  $('.mobile-navigation li.menu-item-has-children ul').hide();

  $('.mobile-navigation li.menu-item-has-children > a').click(function(e) {
    e.preventDefault();
    var submenu = $(this).next('ul');
    if(!$(this).hasClass('open')){
      //open submenu
      $(this).addClass('open');
      $(submenu).slideDown('fast');
    } else {
      //close all child submenus
      $(this).removeClass('open');
      var submenus = $(this).parent().find('ul');
      var parents = $(this).parent().find('.menu-item-has-children a');
      $(submenus).slideUp('fast');
      $(parents).removeClass('open');
    }
  });




  // -----------------------------------------------------------------------------------------------------
  // mobile menu expand - javascript animate version
  // -----------------------------------------------------------------------------------------------------
  // current method is to use CSS3 transitions, but if for any reason you need js, here's how

  // var mobileNavSpeed = 500;
  // var mobileNavEasing = 'easeOutQuint';

  // $('.main-navigation .mobile-menu-trigger').click(function(e) {


  //   if(!$(this).hasClass('open')) {
  //     // open
  //     open_mobile_nav();
  //   } else {
  //     // close
  //     close_mobile_nav();
  //   }

  // });

  // $('.mobile-navigation .close-mobile-menu').click(function(e) {
  //     close_mobile_nav();
  // });


  // function open_mobile_nav(){
  //     // $('.mobile-navigation').stop().animate(
  //     //   {left:0},
  //     //   {
  //     //     duration: mobileNavSpeed,
  //     //     easing: mobileNavEasing
  //     //   },
  //     //   function(){
  //     //     $('this').addClass('open');
  //     //   }
  //     // );

  //     TweenMax.to($('.mobile-navigation'),0.2,{left:0,ease:Power4.easeOut});
  // }
  
  // function close_mobile_nav(){
  //     var width = $('.mobile-navigation').outerWidth();
  //     // $('.mobile-navigation').stop().animate(
  //     //   {left:-(width)},
  //     //   {
  //     //     duration: mobileNavSpeed,
  //     //     easing: mobileNavEasing
  //     //   },
  //     //   function(){
  //     //     $('this').removeClass('open');
  //     //   }
  //     // );
  //     TweenMax.to($('.mobile-navigation'),0.2,{left:-width,ease:Power4.easeOut});
  // }







  // setTimeout(function(){
  //   $('input[type="range"]').rangeslider();
  //   console.log('wtf');
  // },3000);


})(window, document, jQuery);
